function initSitesearch(dataSource) {
    var $ = jQuery, sites;
    $.ajax(dataSource).done(function(data) {
        if(data.status=='OK') {
            loadData(data.data);
        }
        else {
            if(window.console) console.warn(data);
        }
    }).fail(function() {
        if(window.console) console.warn('Ajax call failed', dataSource);
    });

    function loadData(points)  {
        sites = points.filter(function(point) { return point.group=='site' });
        $(document).ready(function() {
            var list = sites.map(function(detail) { return $.extend({}, detail, { id: 'site-'+detail.site_id, value: detail.site_id, lc_id: detail.site_id, label: detail.name }) }),
                $sitesearch = $('input.gm-sitesearch').autocomplete("option", "list", list)
                    .on('sitesearch.fetch', function(event, item) {
                        var list = $(this).autocomplete('option', 'list') || [];
                        if(typeof item == 'number') item = list.find(function(entry) { return entry.site_id==item });
                        if(typeof item == 'string') item = list.find(function(entry) { return entry.id==item });
                        var ac = $(this).data('ui-autocomplete');
                        if(ac) ac._trigger('select', 'autocompleteselect', { item: item });
                    })
                    .each(function() {
                        var mode = 'autocomplete';
                        $('select[name$="-lc_id"][data-search="'+this.id+'"]').each(function() {
                            var $dropdown = $(this);
                            list.map(function(item) { $dropdown.append($('<option>', { value: item.lc_id }).text(item.label)) })
                            $dropdown.val(null);
                            if(list.length <= 20) mode = 'dropdown';
                            $dropdown.change(function(e) { if(e.originalEvent) $sitesearch.trigger('sitesearch.fetch', [+this.value]) })
                        })
                        $(this).closest('.select-site').attr('data-mode', mode).find('.mode-autocomplete input').prop('required', mode=='autocomplete');
                    });
            if(list.length<=1)
                $sitesearch.each(function() {
                    $(this).data('ui-autocomplete')._trigger('select', 'autocompleteselect', { item: list[0] });
                    $(this).closest('.select-site').attr('data-mode', 'default');
                });
        });
    }
}